export default __webpack_public_path__ + "a8690dbd921995017c98346fdee1e865.png";